import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const studentFeesKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'student_fees'] as const, // every student/student_fees query for a specific cause that we have
    id: <U extends QueryKeyParam>(
      uuid: U // uuid here is the fee id
    ) =>
      createQueryKey({
        all: [...keys, 'student_fees', uuid] as const, // all related student_fees for a specific feeId
        detail: [...keys, 'student_fees', uuid, 'detail'] as const,
      }),
    export: [...keys, 'student_fees', 'export'] as const,
  });

export { studentFeesKeys };
